import ShTableColumnFormat from './src/main.vue'

ShTableColumnFormat.install = function (Vue) {
  Vue.component(ShTableColumnFormat.name, TableColumnFormat)
}

export default ShTableColumnFormat
